import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { StepChildProps } from 'sos-common/js/components/WizardStepper/WizardStepper.types';
import { makeTranslator, translateFunc } from '../../../utilities/translations';
import { ResearchOrderStore } from '../../../models/ResearchOrderStore.types';
import { setFormValue } from 'sos-eservice-common/js/Redux/Actions';
import { ResearchOrderModel } from '../../../models/ResearchOrderModel';
import { FieldStates } from 'sos-common/js/commonTypes/formField.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
import { getErrorMessageByFieldName } from '../../../utilities/helpers';
import { Tooltip } from 'sos-common/js/components/Tooltip/Tooltip';

export interface Step4Props extends StepChildProps {
  Translate?: translateFunc;
  researchOrder: ResearchOrderModel;
  setFormValue?: typeof setFormValue;
  validationResults: ValidationResult[];
}
export interface Step4State {
  isValid: boolean;
  stepId: number;
}
class Step4 extends React.Component<Step4Props, Step4State> {
  constructor(props: any) {
    super(props);
    this.state = {
      isValid: this.props.stepState.isDone,
      stepId: this.props.stepState.stepId,
    };
  }
  getTitle = () => 'Beställare';

  onChangeField = (field: FieldStates) => {
    this.props.setFormValue(field);
  };

  componentDidMount() {
    this.props.reportToWizard({
      stepLabel: this.getTitle(),
    });
  }

  public render() {
    const { Translate, researchOrder, validationResults } = this.props;
    return (
      <div id="step4" tabIndex={-1}>
        <label className="h2" htmlFor="research-principal">
          {Translate('/orderFormpage/Forskningshuvudman')}
        </label>
        <div className="inlineblock">
          <Tooltip text={Translate('/orderFormpage/statligMyndighet')} />{' '}
        </div>
        <div className="form-group-small">
          <TextInput
            id="research-principal"
            placeholder={Translate('/orderFormPage/namnPaForskningshuvudman')}
            value={_.get(researchOrder, 'ResearchOrganisation')}
            maxLength={160}
            errorMessage={getErrorMessageByFieldName(validationResults, 'CurrentResearchOrder.ResearchOrganisation')}
            fieldName="CurrentResearchOrder.ResearchOrganisation"
            onChange={this.onChangeField}
            isRequired={true}
            autoComplete="organization"
          />
        </div>
        <hr className="formdivider" />
        <h2>{Translate('/orderFormpage/forskareAnsvarig')}</h2>
        <div className="form-group-small">
          <TextInput
            id="responsible-researcher-name"
            placeholder={Translate('/general/contact/fnAndEn')}
            value={_.get(researchOrder, 'ContactPerson.Name')}
            maxLength={160}
            errorMessage={getErrorMessageByFieldName(validationResults, 'CurrentResearchOrder.ContactPerson.Name')}
            fieldName="CurrentResearchOrder.ContactPerson.Name"
            onChange={this.onChangeField}
            label={Translate('/general/contact/namn') + ' *'}
            isRequired={true}
            autoComplete="name"
          />
        </div>
        <div className="form-group-small">
          <TextInput
            id="responsible-researcher-organisation"
            placeholder={Translate('/general/contact/ogNamn2')}
            value={_.get(researchOrder, 'ContactPerson.Organisation')}
            maxLength={160}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.ContactPerson.Organisation',
            )}
            fieldName="CurrentResearchOrder.ContactPerson.Organisation"
            onChange={this.onChangeField}
            isRequired={true}
            label={Translate('/general/contact/ogNamn1') + ' *'}
            autoComplete="organization"
          />
        </div>
        <div className="form-group-small">
          <TextInput
            id="responsible-researcher-department"
            placeholder={Translate('/orderFormpage/institutionAvdEnhetnamn')}
            value={_.get(researchOrder, 'ContactPerson.Institution')}
            maxLength={160}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.ContactPerson.Institution',
            )}
            fieldName="CurrentResearchOrder.ContactPerson.Institution"
            onChange={this.onChangeField}
            isRequired={true}
            label={Translate('/orderFormpage/instAvdEn') + ' *'}
          />
        </div>
        <div className="form-group-small">
          <TextInput
            id="responsible-researcher-email"
            placeholder={Translate('/general/contact/abcmail')}
            value={_.get(researchOrder, 'ContactPerson.Email')}
            maxLength={160}
            errorMessage={getErrorMessageByFieldName(validationResults, 'CurrentResearchOrder.ContactPerson.Email')}
            fieldName="CurrentResearchOrder.ContactPerson.Email"
            onChange={this.onChangeField}
            isRequired={true}
            label={Translate('/general/contact/epost') + ' *'}
            autoComplete="email"
          />
        </div>
        <div className="form-group-small">
          <TextInput
            id="responsible-researcher-phone"
            placeholder={Translate('/general/contact/examplePhoneNr')}
            value={_.get(researchOrder, 'ContactPerson.Phone')}
            maxLength={26}
            errorMessage={getErrorMessageByFieldName(validationResults, 'CurrentResearchOrder.ContactPerson.Phone')}
            fieldName="CurrentResearchOrder.ContactPerson.Phone"
            onChange={this.onChangeField}
            isRequired={true}
            label={Translate('/general/contact/telf') + ' *'}
            pattern="^[\+0](?:\d\s?)+$"
            autoComplete="tel-national"
          />
        </div>
        <div className="form-group-small">
          <TextInput
            id="responsible-researcher-address"
            placeholder={Translate('/general/address/postadress')}
            value={_.get(researchOrder, 'ContactPerson.Address.StreetAddress')}
            maxLength={160}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.ContactPerson.Address.StreetAddress',
            )}
            fieldName="CurrentResearchOrder.ContactPerson.Address.StreetAddress"
            onChange={this.onChangeField}
            label={Translate('/general/address/gatuEllerBox1') + ' (forskningshuvudman) *'}
            isRequired={true}
            autoComplete="street-address"
          />
        </div>
        <div className="form-group-small">
          <TextInput
            id="responsible-researcher-zip"
            placeholder={'123 45'}
            value={_.get(researchOrder, 'ContactPerson.Address.ZipCode')}
            maxLength={10}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.ContactPerson.Address.ZipCode',
            )}
            fieldName="CurrentResearchOrder.ContactPerson.Address.ZipCode"
            onChange={this.onChangeField}
            isRequired={true}
            label={Translate('/general/address/postnummer3') + ' *'}
            autoComplete="postal-code"
          />
        </div>
        <div className="form-group-small">
          <TextInput
            id="responsible-researcher-state"
            placeholder={Translate('/orderFormpage/ortsnamn')}
            maxLength={160}
            value={_.get(researchOrder, 'ContactPerson.Address.City')}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.ContactPerson.Address.City',
            )}
            fieldName="CurrentResearchOrder.ContactPerson.Address.City"
            onChange={this.onChangeField}
            label={Translate('/general/address/ortLabel') + ' *'}
            isRequired={true}
            autoComplete="address-level1"
          />
        </div>

        <hr className="formdivider" />

        <h2 className="inlineblock">{Translate('/orderFormpage/behorigForetradare')}</h2>
        <div className="inlineblock">
          <Tooltip text={Translate('/orderFormpage/behorigForetradareDesc')} />{' '}
        </div>

        <div className="form-group-small">
          <TextInput
            id="responsible-representative-name"
            placeholder={Translate('/orderFormpage/fnamnOchEftn')}
            value={_.get(researchOrder, 'Representative._Representative.Name')}
            maxLength={160}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.Representative._Representative.Name',
            )}
            fieldName="CurrentResearchOrder.Representative._Representative.Name"
            onChange={this.onChangeField}
            isRequired={true}
            label={Translate('/general/contact/namn') + ' *'}
            autoComplete="name"
          />
        </div>
        <div className="form-group-small">
          <TextInput
            id="responsible-representative-title"
            placeholder={Translate('/orderFormpage/Titel02')}
            value={_.get(researchOrder, 'Representative.WorkTitle')}
            maxLength={160}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.Representative.WorkTitle',
            )}
            fieldName="CurrentResearchOrder.Representative.WorkTitle"
            onChange={this.onChangeField}
            isRequired={true}
            label={Translate('/orderFormpage/tjansteTitel')}
            autoComplete="organization-title"
          />
        </div>
        <div className="form-group-small">
          <TextInput
            id="responsible-representative-department"
            placeholder={Translate('/orderFormpage/instAvdEn')}
            value={_.get(researchOrder, 'Representative._Representative.Institution')}
            maxLength={160}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.Representative._Representative.Institution',
            )}
            fieldName="CurrentResearchOrder.Representative._Representative.Institution"
            onChange={this.onChangeField}
            isRequired={true}
            label={`${Translate('/orderFormpage/instAvdEn')} *`}
          />
        </div>
        <div className="form-group-small">
          <TextInput
            id="responsible-representative-email"
            placeholder={Translate('/general/contact/abcmail')}
            value={_.get(researchOrder, 'Representative._Representative.Email')}
            maxLength={160}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.Representative._Representative.Email',
            )}
            fieldName="CurrentResearchOrder.Representative._Representative.Email"
            onChange={this.onChangeField}
            isRequired={true}
            label={Translate('/general/contact/epost') + ' *'}
            autoComplete="email"
          />
        </div>

        <hr className="formdivider" />

        <h2>{Translate('/general/contact/faktUppgtr')}</h2>
        <div className="form-group-small">
          <TextInput
            id="billing-organisation"
            placeholder={Translate('/general/contact/ogNamn2')}
            value={_.get(researchOrder, 'BillingDetails.Organisation')}
            maxLength={160}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.BillingDetails.Organisation',
            )}
            fieldName="CurrentResearchOrder.BillingDetails.Organisation"
            onChange={this.onChangeField}
            isRequired={true}
            label={Translate('/general/contact/ogNamn1') + ' *'}
            autoComplete="organization"
          />
        </div>
        <div className="form-group-small">
          <TextInput
            id="billing-organisationnumber"
            placeholder={'nnnnnn-nnnn'}
            value={_.get(researchOrder, 'BillingDetails.OrganisationNumber')}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.BillingDetails.OrganisationNumber',
            )}
            fieldName="CurrentResearchOrder.BillingDetails.OrganisationNumber"
            onChange={this.onChangeField}
            isRequired={true}
            label={Translate('/general/contact/ogNummer1') + ' *'}
            //turning autocomplete off, because there is no standardized value
            //for org.nr and chrome suggest org.name instead, which is wrong
            autoComplete="off"
          />
        </div>
        <div className="form-group-small">
          <TextInput
            id="billing-invoicereference"
            placeholder={Translate('/orderFormpage/faktRefsLbl')}
            value={_.get(researchOrder, 'BillingDetails.BillingReference')}
            maxLength={26}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.BillingDetails.BillingReference',
            )}
            fieldName="CurrentResearchOrder.BillingDetails.BillingReference"
            onChange={this.onChangeField}
            isRequired={true}
            label={Translate('/orderFormpage/faktRefs')}
          />
        </div>
        <div className="form-group-small">
          <TextInput
            id="billing-address"
            placeholder={Translate('/general/address/adressGataBox2')}
            value={_.get(researchOrder, 'BillingDetails.BillingAddress.StreetAddress')}
            maxLength={160}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.BillingDetails.BillingAddress.StreetAddress',
            )}
            fieldName="CurrentResearchOrder.BillingDetails.BillingAddress.StreetAddress"
            onChange={this.onChangeField}
            label={Translate('/general/address/adressGataBox2')}
            autoComplete="street-address"
          />
        </div>
        <div className="form-group-small">
          <TextInput
            id="billing-zip"
            placeholder={'123 45'}
            value={_.get(researchOrder, 'BillingDetails.BillingAddress.ZipCode')}
            maxLength={10}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.BillingDetails.BillingAddress.ZipCode',
            )}
            fieldName="CurrentResearchOrder.BillingDetails.BillingAddress.ZipCode"
            onChange={this.onChangeField}
            isRequired={true}
            label={Translate('/general/address/postnummer3') + ' *'}
            autoComplete="postal-code"
          />
        </div>
        <div className="form-group-small">
          <TextInput
            id="billing-state"
            placeholder={Translate('/orderFormpage/ortsnamn')}
            maxLength={160}
            value={_.get(researchOrder, 'BillingDetails.BillingAddress.City')}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.BillingDetails.BillingAddress.City',
            )}
            fieldName="CurrentResearchOrder.BillingDetails.BillingAddress.City"
            onChange={this.onChangeField}
            label={Translate('/general/address/ortLabel') + ' *'}
            isRequired={true}
            autoComplete="address-level1"
          />
        </div>
      </div>
    );
  }
}

const mapState2Props = (state: ResearchOrderStore) => {
  return {
    Translate: makeTranslator(state.globals.translations),
    registers: state.registers,
    researchOrder: state.formModel,
    files: state.files,
    validationResults: state.validationState.validationResults,
  } as Step4Props;
};

const mapDispatch2Props = (dispatch) => {
  return {
    setFormValue: bindActionCreators(setFormValue, dispatch),
  };
};

const StepFour = connect(mapState2Props, mapDispatch2Props)(Step4);
export { StepFour };
